import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin");
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data } });
      } catch (e) {
        navigate("/admin", { state: { error: true } });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center">
      <p className="font-heading uppercase tracking-[0.3em] text-stone text-sm animate-pulse">
        Signing you in…
      </p>
    </div>
  );
}
